import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './typography.css';
import './gptStandards.css';
import './map.css';
import './answerProduct.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root')
);
root.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>
);